import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import Loader from '../../../assests/animation/Loader2.json';
import OverallReview from '../../../components/OverallReview/OverallReview';

import {
  Instagram,
  InstagramIconSmall,
  InstagramLogo,
  X_icon,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import Insta from '../../../assests/images/Instagram.png';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import TrendsInUserActivity from '../../../Common/TendsInUserActivity/TrendsInUser_activity';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import { format, parse } from 'date-fns';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import DynamicCorrelationGraph from '../../../components/DynamicCorrelationGraph/DynamicCorrelationGraph';
import { useDispatch } from 'react-redux';
import { DetailedInsightsData } from '../../../store/redux/slices/topicSlice';
import SidePanel from '../../../components/SidePanel/SidePanel';
import { convertDateFormat, convertDateFormatString } from '../../../utils/ConvertDateFormat';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
const Container = styled.div`
  display: flex;
  gap: 30px;
  height: 380px;
`;

const ChildContainer = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  box-sizing: border-box;
`;

const ChildContainer1 = styled(ChildContainer)`
  width: 50%;
  height: max-content;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  /* justify-content: center; */
  /* align-items: center; */
  box-sizing: border-box;
  padding: 5px;

  span {
    color: #636363;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 0px 10px;
  }

  div {
    margin: 10px 0px 0px 0px;
  }
`;

const OverviewTabInsta = ({
  overview_tab,
  startDate = '',
  endDate = '',
  filteredStartDate,
  filteredEndDate,
  filterOption,
  preview_uuid,
  filteredData,
  job_id,
  resetFlag,
  view,
  channel,
  handleTabClick,
  hideDropdown,
  formatValue = 'dd-yyyy-MM',
}) => {
  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
  const engagementData = [
    {
      name: 'Likes',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.likes
          : overview_tab?.engagement?.likes || 0,
      fill: 'rgba(45, 137, 85, 1)',
      // fill: 'rgba(53, 60, 247, 0.5)',
    },
    {
      name: 'Comments',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.comments
          : overview_tab?.engagement?.comments || 0,
      // fill: '#5FE495',
      fill: ' rgba(45, 137, 85, 0.6)',
    },
    // {
    //   name: 'Shares',
    //   // value: 869,
    //   value: resetFlag === true && filteredData ? filteredData?.engagement?.shares : overview_tab?.engagement?.shares || 0,
    //   fill: '#6F62FE',
    // },
    // {
    //     name:'Saved',
    //     value:resetFlag === true && filteredData ? filteredData?.engagement.saved : overview_tab?.engagement?.saved || 0,
    //     fill:'#AB71CE'
    // }
  ];

  const genderDemographicsData = [
    {
      name: 'Male',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.male_percentage
          : overview_tab?.gender_demographics?.male_percentage || 0,
      // fill: '#6640B8',
      fill: '#3D9FF8',
    },
    {
      name: 'Female',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.female_percentage
          : overview_tab?.gender_demographics?.female_percentage || 0,
      // fill: '#EAAABD',
      fill: '#FF9AB8',
    },
    {
      name: 'Unknown',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.unknown_percentage
          : overview_tab?.gender_demographics?.unknown_percentage || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 217, 219,  0.8)',
    },
  ];

  const totalNoOfPosts =
    resetFlag === true && filteredData
      ? filteredData?.total_count
      : overview_tab?.total_count;

  const renderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          width='105px'
          data={engagementData}
          /*  type={'%'} */
          view={view}
          showFormatted
          showDrillThrough={false}
        />
      ) : (
        <BarGraph
          data={engagementData}
          showFormatted
          isSmall={true}
          showDrillThrough={false}
          /*  type={'%'} */
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        showDrillThrough={false}
        data={engagementData}
        width={450}
      />
    ),
    'Donut Chart': (
      <DonutChart showDrillThrough={false} data={engagementData} />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showDrillThrough={false}
        showFormatted
        data={engagementData}
      />
    ),
  };


  const renderGenderDemography = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          width='105px'
          data={genderDemographicsData}
          type={'%'}
          view={view}
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ) : (
        <BarGraph
          data={genderDemographicsData}
          type={'%'}
          isSmall
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={genderDemographicsData}
        width={450}
        type='percentage'
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
      />
    ),
    'Donut Chart': (
      <DonutChart
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type='percentage'
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type={'%'}
      />
    ),
  };

  const [chartType, setChartType] = useState('Volume');

  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );
  const [graphData, setGraphData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showSidePanel, setShowSidePanel] = useState(false);

  const dispatch = useDispatch();
  const [weekType, setWeekType] = useState(false);
  const [date, setDate] = useState('');

  const handleDataInsightsFetch = async (data) => {
    var inputData = convertDateFormat(data?.date);
    var filter_key = [];

    if (data?.likes_count !== undefined) {
      filter_key.push('likes');
    }
    if (data?.comments_count !== undefined) {
      filter_key.push('comments');
    }
    if (data?.reposts !== undefined) {
      filter_key.push('reposts');
    }
    if (data?.views !== undefined) {
      filter_key.push('views');
    }

    setDate(convertDateFormatString(inputData?.dateString));
    dispatch(
      DetailedInsightsData({
        preview_uuid: preview_uuid,
        job_id: job_id,
        insight_date: inputData?.dateString,
        insight_type: weekType === true ? 'week' : inputData?.type,
        filter_key: filter_key,
      })
    )
      .then((res) => {
        setGraphData(res?.payload?.response);
      })
      .catch((error) => {
        console.error('Error fetching insights:', error);
      });
  };

  return (
    <>
      {resetFlag === true && filteredData === undefined ? (
        <div style={{ marginTop: '-80px' }}>
          <Lottie
            data-testid='loader'
            animationData={Loader}
            loop={true}
            width='100px'
            height='100px'
          />
        </div>
      ) : (
        <Wrapper>
          <SidePanel
            isOpen={showSidePanel}
            setIsOpen={(data) => setShowSidePanel(data)}
            pointGraphData={graphData}
            channel={channel}
            date={date}
            isLoading={graphData === null ? true : false}
            startDate={startDateParsed}
            endDate={endDateParsed}
            chartType={chartType}
          />
          <Container>
            <ChildContainer justify='flex-start'>
              <OverallReview
                inforText='The total number of posts relevant to your topic within the specified time period.'
                 backgroundColor='rgba(45, 137, 85, 1)'
                icon={<img src={Insta} style={{ width: '35px' }} />}
                message={
                  startDateParsed?.length < 1 ||
                  startDateParsed === undefined ||
                  startDateParsed === null
                    ? `${totalNoOfPosts} Relevant posts were observed for this evaluation`
                    : `${totalNoOfPosts} Relevant posts were observed From ${startDateParsed} to ${endDateParsed}`
                }
              />
            </ChildContainer>
            
            <ChildContainer>
              <GraphHOC
                title={'Engagement'}
                options={options}
                renderScreen={renderScreen}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText='The total number of likes and comments on posts relevant to your topic within the specified time period.'
              />
            </ChildContainer>
            {/* )} */}
          </Container>
          <Container>
            <ChildContainer>
              <GraphHOC
                title={'Gender Demographics'}
                options={options}
                renderScreen={renderGenderDemography}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText='The percentage gender distribution of user accounts relevant to your query, with categories for Male, Female, and Unknown when gender data is unavailable.'
             />
            </ChildContainer>
            
          </Container>
          
          <ChildContainer>
            <TrendsInUserActivity
              data1={
                chartType !== 'Engagements'
                  ? {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.volume
                          : overview_tab?.volume,
                    }
                  : {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.trends_in_user_activity
                          : overview_tab?.trends_in_user_activity,
                    }
              }
              ylabel={chartType === 'Engagements' ? 'Engagement' : 'Volume'}
              title={
                chartType === 'Engagements'
                  ? 'Trends in User Activity'
                  : 'Volume'
              }
              hideDropdown={hideDropdown}
              startDate={startDateParsed}
              endDate={endDateParsed}
              formatValue={formatValue}
              showFilters={true}
              setChartType={(data) => setChartType(data)}
              dataPointClickEnabled={true}
              onEmitTimeSpanClick={setWeekType}
              channel={channel}
              handleDataPoint={(data) => {
                setIsLoading(true);
                setGraphData(null);
                handleDataInsightsFetch(data?.payload);
                setIsLoading(false);
                setShowSidePanel(true);
              }}
              infoText={
                chartType === 'Engagements'
                  ? 'Track the total engagement on posts, combining likes, comments, reposts, and views, over a specified time period.'
                  : 'Track the total number of posts over a specified time period.'
              }
              typeVal='instagram'
            />
          </ChildContainer>
          <DynamicCorrelationGraph
            correlationAnalysisData={overview_tab?.heat_map}
            startDate={startDateParsed}
            endDate={endDateParsed}
          ></DynamicCorrelationGraph>
        </Wrapper>
      )}
    </>
  );
};

export default OverviewTabInsta;
